import * as React from "react";

function Exclude(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 69 69" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.167 0C15.297 0 0 15.297 0 34.167s15.297 34.166 34.167 34.166 34.166-15.297 34.166-34.166C68.333 15.297 53.036 0 34.167 0zM21.5 21.5a3.417 3.417 0 014.832 0l7.834 7.835L42 21.5a3.417 3.417 0 114.832 4.832l-7.834 7.834L46.833 42A3.417 3.417 0 1142 46.833l-7.834-7.834-7.834 7.834A3.417 3.417 0 1121.5 42l7.834-7.834-7.834-7.834a3.417 3.417 0 010-4.832z"
        fill={props.color||"red"}
      />
    </svg>
  );
}

export default Exclude;
